module.exports = __webpack_public_path__ + "static/media/banner-bg.73a3bea4.jpg";